import { ApiResponse } from '@models/common/api';
import { IPatient } from '@models/spartacus/patient';

import { get, patch } from './methods';

const BASE_ENDPOINT = 'spartacus/patient';

export interface EnrollPatientInput {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  marketingConsent: boolean;
  messagingConsent: boolean;
}

export interface EnrollmentContext {
  patient: IPatient | null;
  organizationName: string;
}

const enrollmentAPI = {
  findOne: async (content: string): Promise<EnrollmentContext> => {
    const response = await get<ApiResponse<EnrollmentContext>>(`${BASE_ENDPOINT}/enroll/${content}`);
    return response.data.data;
  },

  upsert: async (content: string, body: EnrollPatientInput): Promise<IPatient> => {
    const response = await patch<ApiResponse<IPatient>>(`${BASE_ENDPOINT}/enroll/${content}`, body);
    return response.data.data;
  },
};

export default enrollmentAPI;
